export default __webpack_public_path__ + "static/media/sofia_florez.2972bc67.jpg";